import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './styles/data-block.module.css';
import { DataBlockDataTypes } from '@/constants/DataTypes';
import CandidateListMessage from '@/components/chatbot/Layout/messages/CandidateListMessage';
import JobListMessage from '@/components/chatbot/Layout/messages/JobListMessage';
import { connect } from 'react-redux';
import store from '@/store/store';
import BotMessage from '@/components/chatbot/Layout/messages/BotMessage';
import {
  searchCandidates,
  searchJobs,
} from '@/store/slices/middleware/chatbotFlowThunk';
import { hasAnswer } from '@/helpers/Flow';
import UserMessage from '@/components/chatbot/Layout/messages/UserMessage';
import { animateScroll } from 'react-scroll';

class DataBlock extends Component {
  componentDidMount() {
    const { block } = this.props;
    if (block?.dataType === DataBlockDataTypes.CANDIDATES) {
      store.dispatch(searchCandidates())
    } else if (block?.dataType === DataBlockDataTypes.JOBS) {
      store.dispatch(searchJobs())
    }
  }

  displayData = () => {
    const { block, data, isActive } = this.props;
    switch (block.dataType) {
      case DataBlockDataTypes.CANDIDATES:
        return (
          <CandidateListMessage data={data} isActive={isActive} block={block} />
        );
      case DataBlockDataTypes.JOBS:
        return <JobListMessage data={data} block={block} isActive={isActive} />;
      default:
        return (
          <BotMessage
            block={{
              message:
                'We currently don’t have any roles to match your skill-set.',
            }}
            isActive={isActive}
          />
        );
    }
  };

  render() {
    const { block, isActive, dataLoading } = this.props;
    return dataLoading && isActive ? null : (
      <div className={styles.wrapper}>
        {this.displayData()}
        {hasAnswer(block) && <UserMessage block={block} />}
      </div>
    );
  }
}

DataBlock.propTypes = {
  isActive: PropTypes.bool.isRequired,
  block: PropTypes.object,
};

const mapStateToProps = state => ({
  data: state.chatbotFlow.data,
  dataLoading: state.chatbotFlow.dataLoading,
  isFinished: state.chatbotFlow.isFinished,
  conversation: state.chatbotFlow.conversation,
});

export default connect(mapStateToProps)(DataBlock);
